import * as React from 'react'

import { compact } from 'lodash'

import { observer } from 'mobx-react'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import GroupByField from 'modules/reports/components/Editor/Carcasa/FormFields/GroupByField'
import MultiProjectionField from 'modules/reports/components/Editor/Carcasa/FormFields/MultiProjectionField'
import { useLoadingFields } from 'modules/reports/contexts/loadFieldsContext'
import useFields from 'modules/reports/hooks/useFields'
import { FieldSelectionType } from 'modules/reports/hooks/useReportTracking'
import { ABILITIES, TYPES } from 'modules/reports/lib/Constants'
import type { ReportEditorStore } from 'modules/reports/lib/Store'
import type Field from 'modules/reports/store/models/Field'

const SELECTION_TYPE = FieldSelectionType.Data
const FIELDS_ABILITY_TYPES = [ABILITIES.aggregation, ABILITIES.grouping, ABILITIES.ordering]
const EXCLUDE_TYPES = [TYPES.cohort]
interface Props {
  store: ReportEditorStore
}

const TableView = ({ store }: Props) => {
  const [table, setTable] = React.useState<Field | null>()
  const [, setLoadingFields] = useLoadingFields()
  const loadFields = useFields()

  const handleClickItem = useUnsafeCallback(
    function (fields) {
      if (store.projection.paths().length == 0 && table != fields[0]) {
        loadFields(
          { projections: compact([fields[0]?.attributes.path]) },
          (status) => setLoadingFields(status),
          (status) => setLoadingFields(status)
        )
      }

      setTable(fields[0])
    },
    [loadFields, setLoadingFields, table, store.projection]
  )

  const label = useMemo(
    () => ({
      text: i18n.t('custom_reports.fields.table.initial_data.title'),
      tooltipText: i18n.tView('custom_reports.fields.table.initial_data.tooltip', {}),
    }),
    []
  )

  return (
    <>
      <MultiProjectionField
        selectionType={SELECTION_TYPE}
        onClickItem={handleClickItem}
        store={store}
        fieldAbilityTypes={FIELDS_ABILITY_TYPES}
        excludeIdentifiers
        excludeTypes={EXCLUDE_TYPES}
        label={label}
      />
      <GroupByField store={store} />
    </>
  )
}

export default observer(TableView)
